// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".commonBoxStyle[data-v-820594e2]{width:100%;min-height:45px;float:left;margin-top:5px}", ""]);
// Exports
module.exports = exports;
